import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
	ActivatedRoute
} from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TermsOfUse } from '../models/terms-of-use.model';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { UserAuthService } from '../services/user-auth.service';

@Injectable({
	providedIn: 'root'
})
export class TermsOfUseResolver implements Resolve<Observable<TermsOfUse>> {

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private userAuthService: UserAuthService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.userAuthService.getTermsOfUse(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
